import vmClient from '../../services/vmClient';
import { Entity, EntityStringId, IEntityType, IEntity } from './../../types/entity';
import { IImage, Image } from './Image';
import { IntegerRange, IntegerRangeMarshaller } from './IntegerRange';
import { IText, Text } from './Text';
import { Language, LanguageMarshaller } from 'app/constants/enums/Language';
import { ALL_TRANSLATIONS, TranslationsForEntity } from './translations';
import { IOrganizationReference, OrganizationReference } from './OrganizationReference';

export interface ICategory extends IEntity {
  attributes: {
    bucket: boolean;
    id: EntityStringId;
    language: Language;
    targetLevelRange: IntegerRange;
    teacherNote: string | null;
    visibility: string;
  };
  associations: {
    descriptionText: IText;
    image: IImage | null;
    nameText: IText;
    shortDescriptionText: IText | null;
    owner: IOrganizationReference;
  };
}

export type Category = Entity<ICategory>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Category: IEntityType<ICategory> = vmClient.defineClass({
  typeName: 'Category',
  version: 8,
  persisted: true,
  attributes: {
    language: {
      type: Language,
      marshaller: LanguageMarshaller,
      notNull: true,
    },
    visibility: {
      type: 'string',
      notNull: true,
    },
    bucket: {
      type: 'boolean',
      notNull: true,
    },
    targetLevelRange: {
      type: IntegerRange,
      marshaller: IntegerRangeMarshaller,
      notNull: true,
    },
    teacherNote: 'string',
  },
  associations: {
    nameText: {
      type: Text,
      notNull: true,
    },
    descriptionText: {
      type: Text,
      notNull: true,
    },
    owner: {
      type: OrganizationReference,
      notNull: true,
      shared: true,
    },
    image: Image,
    shortDescriptionText: Text,
  },
});

const CategoryTranslations: Partial<TranslationsForEntity<ICategory>> = {
  nameText: {
    getLabel: (t) => t('entity-fields.Category.nameText.label'),
  },
  descriptionText: {
    getLabel: (t) => t('entity-fields.Category.descriptionText.label'),
  },
  language: {
    getLabel: (t) => t('entity-fields.Category.language.label'),
  },
  targetLevelRange: {
    getLabel: (t) => t('entity-fields.Category.targetLevelRange.label'),
  },
  image: {
    getLabel: (t) => t('entity-fields.Category.image.label'),
  },
  owner: {
    getLabel: (t) => t('entity-fields.Category.owner.label'),
  },
};

ALL_TRANSLATIONS.set(Category, CategoryTranslations);
